import { render } from "./AdminMd.vue?vue&type=template&id=6a0593f7"
import script from "./AdminMd.vue?vue&type=script&lang=js"
export * from "./AdminMd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__